<template>
  <el-popover
    placement="left"
    @show="handleShow">
    <el-select v-model="baseUrl" placeholder="请选择">
      <el-option
        v-for="(item, index) in apiList"
        :key="index"
        :label="item.name + '-' + item.url"
        :value="item.url">
      </el-option>
    </el-select>
    <el-radio-group v-model="store" class="store-select-radio">
      <el-radio label="dev">dev库</el-radio>
      <el-radio label="uat">uat库</el-radio>
    </el-radio-group>
    <el-button size="small" type="primary" @click="submitApiChange">切换</el-button>
    <div slot="reference" id="api-btn" v-drag v-if="isDev">切换接口</div>
  </el-popover>
</template>

<script>
import Cookies from 'js-cookie'
export default {
  computed: {
    isDev () {
      return process.env.NODE_ENV === 'dev'
    }
  },
  data () {
    return {
      apiList: [
        {
          url: 'http://10.204.42.139:9099',
          name: '钟真元'
        },
        {
          url: 'http://10.204.42.121:9099',
          name: '于薪斌'
        },
        {
          url: 'http://10.204.42.156:9099',
          name: '谢炳卓'
        },
        {
          url: 'http://10.204.42.139:9099',
          name: '钟真元'
        },
        {
          url: 'https://dev.keyclass.cn',
          name: '开发'
        },
        {
          url: 'https://uat.keyclass.cn',
          name: '测试'
        }
      ],
      baseUrl: '',
      store: ''
    }
  },
  methods: {
    submitApiChange () {
      Cookies.set('qd_baseUrl', this.baseUrl)
      Cookies.set('qd_store', this.store)
      location.reload()
    },
    handleShow () {
      this.baseUrl = Cookies.get('qd_baseUrl')
      this.store = Cookies.get('qd_store')
    }
  }
}
</script>

<style lang="less" scoped>
#api-btn{
  position: fixed;
  top: 0;
  left: calc(100% - 200px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px!important;
  background-color: #67C23A;
  color: #fff;
  border-radius: 10px;
  cursor: pointer;
  z-index: 9999;
}
.store-select-radio label.el-radio{
  margin-right: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/ApiSelect.vue